import { StepIndicator } from "@/shared/ui/StepIndicator";

import { STEPS } from "../model/siteStep";

/**
 * 站点三段条(生成 → 预览调整 → 上线,1010)。
 * `current` 由 `stepOf(site)` 派生,这里不存状态、不可点(StepIndicator 的两条纪律)。
 */
export function SiteSteps({ current, className }: { current: number; className?: string }) {
  return (
    <StepIndicator
      steps={STEPS}
      current={current}
      label="建站流程"
      domainAttr="data-website-steps"
      className={className}
    />
  );
}
